import React from 'react'

import Navigation from '../Navigation/Navigation'

import './Header.css'

const Header = ({ burgerOpen, handleBurgerCLick }) => (
  <div className="fmbm-header">
    <Navigation burgerOpen={burgerOpen} handleBurgerCLick={handleBurgerCLick} />
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js